import { useTranslation } from 'react-i18next';
import {
  KYC_DOCUMENT_TYPES,
  UtilityBill,
  BankStatement,
  VoidedCheck,
} from '../util/constants';
import IdCardIcon from '../components/Icons/IdCardIcon';
import CheckIcon from '../components/Icons/CheckIcon';
import { PAGES } from '../constants/pages';
import { getDocumentsByApplicantType } from '../util/helpers/kycDocumentsFiltering';

const useKycProofOfResidencyDocuments = (requiredDocuments, applicantType) => {
  const { t } = useTranslation();

  const getPath = (value) =>
    PAGES.KYC_PROOF_OF_RESIDENCE[String(applicantType).toUpperCase()].UPLOAD[
      value
    ];

  const getResidencyDocuments = (documents) => {
    const documentsByApplicantType = getDocumentsByApplicantType(
      documents,
      applicantType,
    );
    return documentsByApplicantType.filter(
      (document) =>
        [UtilityBill, BankStatement, VoidedCheck].indexOf(
          KYC_DOCUMENT_TYPES[`${document.DocumentType}`],
        ) > -1,
    );
  };

  const filterResidencyDocumentsBasedOnType = (documents) =>
    documents.flatMap((document) => {
      switch (KYC_DOCUMENT_TYPES[`${document.DocumentType}`]) {
        case UtilityBill:
          return [
            {
              ...document,
              title: t('kycVerification.utilityBill'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              path: getPath('UTILITY_BILL'),
            },
          ];

        case BankStatement:
          return [
            {
              ...document,
              title: t('kycVerification.bankStatement'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              path: getPath('BANK_STATEMENT'),
            },
          ];
        case VoidedCheck:
          return [
            {
              ...document,
              title: t('kycVerification.voidedCheck'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              path: getPath('VOIDED_CHECK'),
            },
          ];
        default:
          return [
            {
              ...document,
              title: t('kycVerification.utilityBill'),
              Icon: document.IsUploaded ? CheckIcon : IdCardIcon,
              path: getPath(document.DocumentType),
            },
          ];
      }
    });

  const kycResidencyOptions = () => {
    if (!requiredDocuments.length) return;

    const residencyDocuments = getResidencyDocuments(requiredDocuments);

    const documents = filterResidencyDocumentsBasedOnType(residencyDocuments);

    return documents;
  };

  return { kycResidencyOptions };
};

useKycProofOfResidencyDocuments.propTypes = {};

export default useKycProofOfResidencyDocuments;
